import { render, staticRenderFns } from "./cart-btn.vue?vue&type=template&id=0c439b1d&scoped=true&"
import script from "./cart-btn.vue?vue&type=script&lang=js&"
export * from "./cart-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c439b1d",
  null
  
)

export default component.exports